import { useEffect } from 'react';
import { AuthGuard, AuthProvider } from './auth/AuthProvider';
import { useAuth } from './auth/useAuth';
import { Dashboard } from './components/Dashboard';
import {
  accountToUser,
  startSessionHeartbeat,
  stopSessionHeartbeat,
} from './observability/sessionHeartbeat';

export function App() {
  // Teams SDK initialization is lazy in src/teams.ts; it fires on the first
  // context/token call from AuthGuard or useAuth.
  return (
    <AuthProvider>
      <AuthGuard>
        <SessionHeartbeat />
        <Dashboard />
      </AuthGuard>
    </AuthProvider>
  );
}

// Rendered inside AuthGuard so it only mounts when an account exists (either
// MSAL or Teams-synth). Keeps the usage.heartbeat effect out of Dashboard
// where it would mix with render concerns.
function SessionHeartbeat() {
  const { account } = useAuth();

  useEffect(() => {
    if (!account) return;
    startSessionHeartbeat(accountToUser(account));
    return () => stopSessionHeartbeat();
  }, [account]);

  return null;
}
